<template>
  <div class="print-receipt-order-dialog">
    <div class="bg"></div>
    <div class="dialog-content">
      <div class="print-content" ref="print">
        <div class="title-content">
          <div class="title-top">{{ title }}</div>
          <div class="title-bottom">{{ $t('crm_print_order_dialog.zlsbqrqsd') }}</div>
        </div>
        <div class="details">
          <div class="send">{{ $t('crm_print_order_dialog.gong_huo_fang') }}：{{ shipperOrgName }}</div>
          <div class="receipt">{{ $t('crm_print_order_dialog.shou_huo_fang') }}：{{ consigneeOrgName }}</div>
          <div class="tips">{{ tips }}</div>
        </div>
        <div class="table-bd">
          <!-- <custom-table height="100%" :data="tableList" :tableCode="tableCode" :index="true" @filter="filterChange"
            @sort="sortChange" :slots="['remark']">
            <template v-slot:remark="scope">
              <div class="remark">{{ scope.row.remark }}</div>
            </template>
          </custom-table> -->
          <table class="border-table">
            <thead>
              <tr>
                <th v-for="(item, index) in cols" :key="index" :style="{ width: item.width + 'px' }">{{ item.columnName }}</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(row, rowIndex) in tableList" :key="'row_' + rowIndex">
                <td v-for="(item, index) in cols" rowspan="1" colspan="1" :key="index" class="td" :style="{ width: item.width + 'px' }">
                  {{ formatColumn(row, { index: index, property: item.columnCode }) }}
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <div class="company-container">
          <div class="right-content">
            <div class="item">
              <div class="key">{{ $t('crm_print_order_dialog.gsmcgzc') }}：</div>
            </div>
            <div class="item">
              <div class="key">{{ $t('crm_print_order_dialog.que_ren_ren') }}：</div>
            </div>
            <div class="item">
              <div class="key">{{ $t('Common.com_date') }}：</div>
            </div>
          </div>
        </div>
      </div>

      <div class="dialog-footer">
        <el-button @click="onCancel">{{ $t('Common.com_close') }}</el-button>
        <el-button v-if="hasPrint === false && printVisible" type="primary" @click="onPrint">{{ $t('crm_print_order_dialog.da_yin') }}</el-button>
      </div>
    </div>
  </div>
</template>

<script>
import apis from '@/utils/apis';

export default {
  props: {
    model: {
      type: Object,
      default() {
        return {};
      },
    },
    // 是否允许打印
    printVisible: {
      type: Boolean,
      default: true,
    },
  },
  computed: {
    title() {
      if (this.yearStr) {
        return this.$t('crm_print_order_dialog.onianoyue', [this.year,this.month]);
      }
      return '';
    },
    // 供货公司
    shipperOrgName() {
      if (this.model.data) {
        return this.model.data.shipperOrgName;
      }
      return '';
    },
    // 收货公司
    consigneeOrgName() {
      if (this.model.data) {
        return this.model.data.consigneeOrgName;
      }
      return '';
    },
    // tips
    tips() {
      if (this.yearStr) {
        const txt = this.$t('crm_print_order_dialog.yxwwsonoyfhhtjkcjgot', [this.year,this.month,this.tableList.length]);
        return this.$t('crm_print_order_dialog.oqqryxsbsfgzrnqrqhxx', [txt]);
      }
      return '';
    },
  },
  data() {
    return {
      tableCode: 'device_rental_receipt_order',
      formSearch: {
        search: '',
        pageSize: 50,
        pageNum: 1,
      },
      tableList: [],
      totalRows: null,
      yearStr: '',
      year: '',
      monthStr: '',
      month: '',
      hasPrint: false,
      cols: [],
      propertyMap: {},
      bas_tableField_dateFormat: {},
      columnDictionary: {},
    };
  },
  mounted() {
    this.init();
  },
  methods: {
    // 获取表格列
    getCols: function () {
      if (!this.tableCode) {
        return;
      }
      this.$getJSON(apis.TableColumnGet, { tableCode: this.tableCode }).then((res) => {
        let tableColumn = res.data || [];
        // 过滤表格列
        if (this.onlyArr && this.onlyArr.length) {
          tableColumn = tableColumn.filter((col) => this.onlyArr.includes(col.columnCode));
        }
        if (this.filterArr && this.filterArr.length) {
          tableColumn = tableColumn.filter((t) => !this.filterArr.includes(t.columnCode));
        }
        // 获取字典
        const codes = tableColumn.filter((t) => t.isFormat && t.formatRule === 'dic_group').map((f) => f.dicGroup);
        const hasDate = tableColumn.find((t) => t.formatRule === 'tableField_date');
        if (hasDate) {
          codes.push('bas_tableField_dateFormat');
        }
        if (codes.length) {
          this.getDictionary(
            codes.join(','),
            (dictionary) => {
              tableColumn.forEach((item) => {
                // 多选表格列过滤
                if (item.isFormat && item.formatRule === 'dic_group' && item.checkbox) {
                  const propList = dictionary[item.dicGroup].map((t) => ({ text: t.name, value: t.value, code: t.code }));
                  if (!item.checkboxRule) {
                    item.filters = propList;
                    return;
                  }
                  const ruleReg = /^\[|\]$/g;
                  const rules = item.checkboxRule.replace(ruleReg, '').split(',');
                  if (ruleReg.test(item.checkboxRule)) {
                    item.filters = propList.filter((t) => !rules.includes(t.code));
                  } else {
                    item.filters = propList.filter((t) => rules.includes(t.code));
                  }
                }
              });
              this.cols = tableColumn;
            },
            'columnDictionary'
          );
        } else {
          this.cols = tableColumn;
        }
      });
    },
    // 格式化表格列
    formatColumn: function (row, col) {
      const column = this.cols[col.index];
      if (column.isFormat) {
        const dictionary = this.tableCode ? this.columnDictionary : this.$store.state.dictionary;
        let result = '';
        // 格式化字典
        if (column.formatRule === 'dic_group' && column.dicGroup) {
          const group = this.$transformDicValue(dictionary[column.dicGroup]);
          const value = row[col.property];
          result = group[`${value}`] || value || '-';
        }
        // 格式化日期
        if (column.formatRule === 'tableField_date' && column.dicGroup) {
          const group = this.$transformDicCode(dictionary.bas_tableField_dateFormat);
          const param = group[column.dicGroup];
          try {
            if (param === 'formatSecToHm') {
              // formatSecToHm
              // 特殊处理时间 h:m
              const field = col.property.replace('Format', '');
              result = this[`$${param}`](row[field]);
            } else if (param === 'toFixed') {
              // 如果是0 '-' 要用'-' 显示
              if (!row[col.property] || row[col.property] === '-') {
                result = '-';
              } else {
                // toFixed 数据保留两位小数特殊处理
                result = this[`$${param}`](row[col.property]);
              }
            } else if (row[col.property]) {
              result = this.$momentLocal(row[col.property], param);
            }
          } catch (e) {
            //
          }
        }
        return result === undefined || result === '' ? '-' : result;
      } else {
        const value = row[col.property];
        return value === undefined || value === '' ? '-' : value;
      }
    },
    onPrint() {
      this.hasPrint = true;
      this.$print(this.$refs.print);
    },
    initDate() {
      if (this.model.data && this.model.data.shipmentMonth) {
        const shipmentMonth = `${this.model.data.shipmentMonth}`;
        const yearStr = shipmentMonth.slice(0, 4);
        const monthStr = shipmentMonth.slice(-2);
        const year = parseInt(yearStr, 10);
        const month = parseInt(monthStr, 10);
        this.yearStr = yearStr;
        this.year = year;
        this.monthStr = monthStr;
        this.month = month;
      }
    },
    async init() {
      await this.getTableList();

      this.getCols();

      this.initDate();

      if (this.model.type === 'print') {
        setTimeout(() => {
          this.onPrint();
        }, 1000);
      }
    },
    getTableList() {
      return this.$getJSON(apis.orderDeliveryMonthDetail, this.getReqData()).then((res) => {
        this.tableList = res.data;
        this.totalRows = res.data.length;
      });
    },
    getReqData() {
      const ret = {
        ...this.formSearch,
        orderDeliveryMonthId: this.model.data.orderDeliveryMonthId,
      };
      return ret;
    },
    onConfirm() {},
    onCancel() {
      this.close();
    },
    close() {
      this.$emit('close');
    },
  },
};
</script>

<style lang="scss">
$pageWidth: 760px;

.print-receipt-order-dialog {
  position: fixed;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  z-index: 10000;

  .table-bd {
    overflow-y: auto;
  }

  .border-table {
    width: 100%;
    table-layout: fixed;
    border-collapse: collapse;

    th,
    td {
      border: 1px solid #000;
      padding: 10px 0 10px 10px;
      text-align: left;
      // display: table-cell;
      // width: 100px;
      /*允许在单词内换行。*/
      word-break: break-word;
    }
  }

  .bg {
    position: absolute;
    width: 100%;
    height: 100%;
    left: 0;
    top: 0;
    z-index: 0;
    background: #000;
    opacity: 0.3;
  }

  .dialog-content {
    position: absolute;
    z-index: 10;
    width: $pageWidth;
    min-height: 600px;
    max-height: 800px;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    margin: auto;
    background-color: #fff;
    display: flex;
    flex-direction: column;
  }

  .print-content {
    padding: 16px;
    flex: 1;
    display: flex;
    flex-direction: column;
    overflow: hidden;
  }

  .title-content {
    text-align: center;
    font-weight: bold;
    line-height: 1.4;

    .title-top {
      font-size: 18px;
    }

    .title-bottom {
      font-size: 20px;
    }
  }

  .details {
    margin-top: 20px;
    font-size: 12px;
    line-height: 26px;
    word-break: break-all;
  }

  .table-bd {
    margin-top: 20px;
  }

  .remark {
    word-break: break-all;
    white-space: normal;
  }

  .dialog-footer {
    padding-bottom: 16px;
    padding-right: 16px;
    text-align: right;
  }

  .company-container {
    overflow: hidden;
    padding: 20px 20px 20px 0;

    .right-content {
      float: right;
      width: 100%;

      .item {
        overflow: hidden;
        width: 100%;
        padding-right: 200px;

        float: left;
        text-align: right;
        font-size: 12px;
        line-height: 26px;
        margin-bottom: 10px;
      }
    }
  }
}

@media print {
  *noprint::after {
    content: '' !important;
  }

  // 去掉页眉 页尾
  .header,
  .footer {
    display: none;
  }

  @page {
    // size: auto; /* auto is the initial value */
    // margin: 3mm; /* this affects the margin in the printer settings */
    size: A4 portrait;
    margin: 1.5cm 0.5cm 0mm;
    font-family: 'SimSun', '宋体' !important;
  }

  html {
    background-color: #ffffff;
    margin: 0px;
    /* this affects the margin on the html before sending to printer */
    font-family: 'SimSun', '宋体' !important;
  }

  body {
    // border: solid 1px blue ;
    margin: 10mm 15mm 10mm 15mm;
    /* margin you want for the content */
    font-family: 'SimSun', '宋体' !important;
  }

  // 打印样式
  h2 {
    height: 40px;
    font-size: 28px;
    font-weight: bold;
    color: rgba(57, 70, 104, 1);
    line-height: 40px;
    margin-bottom: 40px;
    text-align: center;
  }

  // .table-bd {
  //   width: 100%;
  //   border: 1px solid #333;
  // }

  .table-bd {
    overflow-y: auto;
  }

  .border-table {
    width: 100%;
    table-layout: fixed;
    border-collapse: collapse;

    th,
    td {
      border: 1px solid #000;
      padding: 10px 0 10px 10px;
      text-align: left;
      // display: table-cell;
      // width: 100px;
      /*允许在单词内换行。*/
      word-break: break-word;
    }
  }

  .el-table {
    width: 100%;
  }

  table {
    width: 100%;
    // border: 1px solid #333;

    th {
      font-size: 12px;
      color: #000;
      font-weight: normal !important;
      text-align: left;
      padding: 0 5px;
      line-height: 30px;
      background-color: #f2f3fb !important;
      // width: calc(100% /6);
    }
  }

  .dialog-content {
    position: absolute;
    z-index: 10;
    width: $pageWidth;
    min-height: 600px;
    max-height: 800px;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    margin: auto;
    background-color: #fff;
    display: flex;
    flex-direction: column;
  }

  .print-content {
    padding: 16px;
    flex: 1;
    display: flex;
    flex-direction: column;
    overflow: hidden;
  }

  .title-content {
    text-align: center;
    font-weight: bold;
    line-height: 1.4;

    .title-top {
      font-size: 18px;
    }

    .title-bottom {
      font-size: 20px;
    }
  }

  .details {
    margin-top: 20px;
    font-size: 12px;
    line-height: 26px;
    word-break: break-all;
  }

  .table-bd {
    margin-top: 20px;
  }

  .remark {
    word-break: break-all;
    white-space: normal;
  }

  .dialog-footer {
    padding-bottom: 16px;
    padding-right: 16px;
    text-align: right;
  }

  .company-container {
    overflow: hidden;
    padding: 20px 20px 20px 0;

    .right-content {
      float: right;
      width: 100%;

      .item {
        overflow: hidden;
        width: 100%;
        padding-right: 200px;

        float: left;
        text-align: right;
        font-size: 12px;
        line-height: 26px;
        margin-bottom: 10px;
      }
    }
  }
}
</style>
